<template lang="pug">
include /mixins

div
  +b.g-row--align_center.--appearance_column
    +b.g-cell.g-cols--12
      +b.ds-caption.--size_md.--medium.--appearance_center.P {{ _('Введите код из SMS или Viber, отправленный на') }}:
        strong(style='padding-left: 4px') {{ phone }}
    +b.g-cell.g-cols--12.tt-space_mt--3
      +b.g-row--align_center.--justify_center
        +b.g-cell.g-cols
          +b.tt-link--styling_default.ds-caption--size_xs.--color_accent.A(
            @click.prevent='$emit("change-phone")'
          )
            +e.title.SPAN {{ _('Сменить телефон') }}
    +b.relative.tt-space_mt--10.tt-space_mb--10
      validation-provider(
        :rules="'required|length:6'"
        v-slot="{ errors }"
        name='code'
      )
        otp-input(ref='otp' :value='code' :length='6' :is-load='isLoad' @input='$emit("update:code", $event)')
        +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
        +b.error-label--top.LABEL(v-if="errorCode") {{ errorCode }}
    +b.g-cell.g-cols--12
      +b.g-row--justify_center
        resend-timer(:time='60000')
          template(#default='{ minutes, seconds }')
            +b.g-cell.g-cols
              +b.ds-caption.--size_2xs.--appearance_center.P(
                v-if='minutes || seconds'
              ) {{ _('Повторить отправку можно через') }} #[span(class='timer-text') {{ minutes|dateTime }}:{{ seconds|dateTime }} ]
              +b.tt-link--variant_start.--styling_default.ds-caption--size_xs.--size_sm-xl.--appearance_center.A(
                @click.prevent='$emit("resend")'
                v-else
              )
                +e.text.P {{ _('Отправить пароль заново') }}
</template>

<script>
import ResendTimer from '@app/Order/ResendTimer'

export default {
  name: 'StepOtp',
  components: { ResendTimer },
  props: {
    phone: { type: String, default: '' },
    code: { type: String, default: '' },
    isLoad: { type: Boolean, default: false },
    errorCode: { type: String, default: '' },
  },
  methods: {
    clearPin() {
      if (this.$refs.otp) this.$refs.otp.clearPin()
    },
  },
}
</script>
